
import apiEndpoints from '../../../axios/api';
import axiosInstance from '../../axiosInstance';
import { notify } from '../../../utils/notification';
import { selectedSocietyStorer } from '../../../utils/webStorer';

/* =========================
   WINGS REQUESTS
========================= */

export const getWingsReq = (action) => {
    const searchQuery = action?.data || {};
    const params = {
        page: searchQuery.page || 1,
        limit: searchQuery.limit || 10,
    };

    // Only add optional params if they have values
    if (searchQuery.search) params.search = searchQuery.search;
    if (searchQuery.society_id) params.society_id = searchQuery.society_id;
    if (searchQuery.wing_type) params.wing_type = searchQuery.wing_type;
    if (searchQuery.status) params.status = searchQuery.status;

    return axiosInstance.get(apiEndpoints.SOCIETY_GET_WINGS_API, { params })
        .then(response => response)
        .catch((errors) => {
            console.log("errors", errors);
            const status = errors.response?.status;
            const message = errors.response?.data?.message;
            if (status === 400 || status === 404) {
                notify('error', message || 'An error occurred');
            } else {
                notify('warning', message || "Something went wrong");
            }
            return { success: false, message };
        });
};

/* =========================
   GET WING DETAILS
========================= */
export const getWingDetailsReq = (action) => {
    const wingId = action?.data?.id || '';
    const url = apiEndpoints.SOCIETY_GET_WING_DETAILS_API.replace(':id', wingId);

    return axiosInstance.get(url)
        .then(response => response)
        .catch((errors) => {
            console.log("errors", errors);
            const status = errors.response?.status;
            const message = errors.response?.data?.message;
            if (status === 400 || status === 404) {
                notify('error', message || 'An error occurred');
            } else {
                notify('warning', message || "Something went wrong");
            }
            return { success: false, message };
        });
};

/* =========================
   CREATE WING
========================= */
export const createWingsReq = (action) => {
    let payload = { ...action?.data } || {};
    delete payload.id;
    delete payload.onSuccess;

    return axiosInstance.post(apiEndpoints.SOCIETY_CREATE_WINGS_API, payload)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            const status = errors.response?.status;
            const message = errors.response?.data?.message;
            if (status === 400 || status === 404 || status === 409) {
                notify('error', message || 'An error occurred');
            } else {
                notify('warning', message || "Something went wrong");
            }
            return { success: false, message };
        });
};

/* =========================
   EDIT WING
========================= */
export const editWingsReq = (action) => {
    const wingId = action?.data?.id || '';
    let payload = { ...action?.data } || {};
    delete payload.id;
    delete payload.onSuccess;

    const url = apiEndpoints.SOCIETY_EDIT_WINGS_API.replace(':id', wingId);

    return axiosInstance.put(url, payload)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            const status = errors.response?.status;
            const message = errors.response?.data?.message;
            if (status === 400 || status === 404 || status === 409) {
                notify('error', message || 'An error occurred');
            } else {
                notify('warning', message || "Something went wrong");
            }
            return { success: false, message };
        });
};

/* =========================
   DELETE WING
========================= */
export const deleteWingsReq = (action) => {
    const wingId = action?.data?.id || '';
    const societyId = action?.data?.society_id || '';
    const url = apiEndpoints.SOCIETY_DELETE_WINGS_API.replace(':id', wingId);

    return axiosInstance.delete(url, { params: { society_id: societyId } })
        .then(response => response)
        .catch((errors) => {
            console.log("errors", errors);
            const status = errors.response?.status;
            const message = errors.response?.data?.message;
            if (status === 400 || status === 404) {
                notify('error', message || 'An error occurred');
            } else {
                notify('warning', message || "Something went wrong");
            }
            return { success: false, message };
        });
};


/* =========================
   GET FLATS
========================= */
export const getFlatsReq = (action) => {
    const searchQuery = action?.data || {};
    const params = {
        page: searchQuery.page || 1,
        limit: searchQuery.limit || 10,
    };

    // Only add optional params if they have values
    if (searchQuery.search) params.search = searchQuery.search;
    if (searchQuery.wing_id) params.wing_id = searchQuery.wing_id;
    if (searchQuery.flat_type) params.flat_type = searchQuery.flat_type;
    if (searchQuery.ownership_type) params.ownership_type = searchQuery.ownership_type;
    if (searchQuery.status) params.status = searchQuery.status;
    if (searchQuery.floor_number) params.floor_number = searchQuery.floor_number;

    return axiosInstance.get(apiEndpoints.SOCIETY_GET_FLATS_API, { params })
        .then(response => response)
        .catch((errors) => {
            console.log('errors', errors);
            const status = errors.response?.status;
            const message = errors.response?.data?.message;
            if (status === 400 || status === 404) {
                notify('error', message || 'An error occurred');
            } else {
                notify('warning', message || 'Something went wrong');
            }
            return { success: false, message };
        });
};

/* =========================
   GET FLAT DETAILS
========================= */
export const getFlatDetailsReq = (action) => {
    const flatId = action?.data?.id || '';
    const url = apiEndpoints.SOCIETY_GET_FLAT_DETAILS_API.replace(':id', flatId);

    return axiosInstance.get(url)
        .then(response => response)
        .catch((errors) => {
            console.log('errors', errors);
            const status = errors.response?.status;
            const message = errors.response?.data?.message;
            if (status === 400 || status === 404) {
                notify('error', message || 'An error occurred');
            } else {
                notify('warning', message || 'Something went wrong');
            }
            return { success: false, message };
        });
};

/* =========================
   CREATE FLAT
========================= */
export const createFlatReq = (action) => {
    let payload = { ...action?.data } || {};
    delete payload.id;
    delete payload.onSuccess;

    // Same society-context wiring as editFlatReq — see comment there for why.
    const societyId = selectedSocietyStorer.getSocietyId();
    if (societyId && !payload.society_id) payload.society_id = societyId;
    const config = societyId ? { headers: { 'X-Society-Id': societyId } } : undefined;

    return axiosInstance.post(apiEndpoints.SOCIETY_CREATE_FLAT_API, payload, config)
        .then(response => response)
        .catch((errors) => {
            console.log('errors', errors);
            const status = errors.response?.status;
            const message = errors.response?.data?.message;
            if (status === 400 || status === 404 || status === 409) {
                notify('error', message || 'An error occurred');
            } else {
                notify('warning', message || 'Something went wrong');
            }
            return { success: false, message };
        });
};

/* =========================
   EDIT FLAT
========================= */
export const editFlatReq = (action) => {
    const flatId = action?.data?.id || '';
    let payload = { ...action?.data } || {};
    delete payload.id;
    delete payload.onSuccess;

    // BE societyContextMiddleware needs a society_id from body / query /
    // X-Society-Id header (or single-membership fallback, which super admins
    // bypass). The edit-flat payload doesn't carry it naturally — the user
    // is editing an existing flat by id — so pull the active society from
    // the storer and pass it both as body + header. Header matches the
    // TaskReqs pattern used elsewhere.
    const societyId = selectedSocietyStorer.getSocietyId();
    if (societyId && !payload.society_id) payload.society_id = societyId;

    const url = apiEndpoints.SOCIETY_EDIT_FLAT_API.replace(':id', flatId);
    const config = societyId ? { headers: { 'X-Society-Id': societyId } } : undefined;

    return axiosInstance.put(url, payload, config)
        .then(response => response)
        .catch((errors) => {
            console.log('errors', errors);
            const status = errors.response?.status;
            const message = errors.response?.data?.message;
            if (status === 400 || status === 404 || status === 409) {
                notify('error', message || 'An error occurred');
            } else {
                notify('warning', message || 'Something went wrong');
            }
            return { success: false, message };
        });
};

/* =========================
   DELETE FLAT
========================= */
/* =========================
   WINGS DROPDOWN
========================= */
export const getWingsDropdownReq = (action) => {
    const searchQuery = action?.data || {};
    const params = {};
    if (searchQuery.society_id) params.society_id = searchQuery.society_id;

    return axiosInstance.get(apiEndpoints.SOCIETY_GET_WINGS_DROPDOWN_API, { params })
        .then(response => response)
        .catch((errors) => {
            console.log("errors", errors);
            const message = errors.response?.data?.message;
            notify('warning', message || "Something went wrong");
            return { success: false, message };
        });
};

/* =========================
   FLATS DROPDOWN
========================= */
export const getFlatsDropdownReq = (action) => {
    const searchQuery = action?.data || {};
    const params = {};
    if (searchQuery.wing_id) params.wing_id = searchQuery.wing_id;
    const societyId = searchQuery.society_id || selectedSocietyStorer.getSocietyId();
    if (societyId) params.society_id = societyId;

    return axiosInstance.get(apiEndpoints.SOCIETY_GET_FLATS_DROPDOWN_API, { params })
        .then(response => response)
        .catch((errors) => {
            console.log("errors", errors);
            const message = errors.response?.data?.message;
            notify('warning', message || "Something went wrong");
            return { success: false, message };
        });
};

export const deleteFlatReq = (action) => {
    const flatId = action?.data?.id || '';
    const url = apiEndpoints.SOCIETY_DELETE_FLAT_API.replace(':id', flatId);

    // Delete carries no body, so the middleware can only find society_id via
    // the header. Passes through as noop when the storer has nothing.
    const societyId = selectedSocietyStorer.getSocietyId();
    const config = societyId ? { headers: { 'X-Society-Id': societyId } } : undefined;

    return axiosInstance.delete(url, config)
        .then(response => response)
        .catch((errors) => {
            console.log('errors', errors);
            const status = errors.response?.status;
            const message = errors.response?.data?.message;
            if (status === 400 || status === 404) {
                notify('error', message || 'An error occurred');
            } else {
                notify('warning', message || 'Something went wrong');
            }
            return { success: false, message };
        });
};

/* =========================
   BULK UPLOAD — WINGS / FLATS
========================= */
export const bulkUploadWingsReq = (action) => {
    const { file, society_id } = action.data || {};
    const formData = new FormData();
    if (file) formData.append('file', file);
    if (society_id) formData.append('society_id', society_id);
    return axiosInstance.post(apiEndpoints.SOCIETY_BULK_UPLOAD_WINGS_API, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    })
        .then(res => {
            if (res?.success) notify('success', res.message || 'Wings uploaded');
            return res;
        })
        .catch(err => {
            const msg = err?.response?.data?.message || 'Failed to upload wings';
            notify('warning', msg);
            return { success: false, message: msg };
        });
};

export const bulkUploadFlatsReq = (action) => {
    const { file, society_id, wing_id } = action.data || {};
    const formData = new FormData();
    if (file) formData.append('file', file);
    if (society_id) formData.append('society_id', society_id);
    if (wing_id) formData.append('wing_id', wing_id);
    return axiosInstance.post(apiEndpoints.SOCIETY_BULK_UPLOAD_FLATS_API, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    })
        .then(res => {
            if (res?.success) notify('success', res.message || 'Flats uploaded');
            return res;
        })
        .catch(err => {
            const msg = err?.response?.data?.message || 'Failed to upload flats';
            notify('warning', msg);
            return { success: false, message: msg };
        });
};

/* =========================
   FLATS WITH OWNERSHIP
========================= */
export const getFlatsWithOwnershipReq = (action) => {
    const searchQuery = action?.data || {};
    const params = {};
    if (searchQuery.society_id) params.society_id = searchQuery.society_id;
    if (searchQuery.wing_id) params.wing_id = searchQuery.wing_id;

    return axiosInstance.get(apiEndpoints.SOCIETY_GET_FLATS_WITH_OWNERSHIP_API, { params })
        .then(response => response)
        .catch((errors) => {
            console.log("errors", errors);
            const message = errors.response?.data?.message;
            notify('warning', message || "Something went wrong");
            return { success: false, message };
        });
};